import React from 'react';
import { getApplyLink, getInstitutionId, getOfferId, getProductId, getProductType } from '@nerdwallet/marketplace/selectors/common';
import BaseImpression from '../base-impression';
import { getMonetizable } from '../../lib/utils';

/**
 * Since the main reason is for product impression and the product impression
 * does not require an entityName we use the hook instead and also do not
 * require the entityName
 */
var BaseMarketplaceImpression = function BaseMarketplaceImpression(_ref) {
  var children = _ref.children,
      marketplaceEntity = _ref.marketplaceEntity,
      productImpressionProps = _ref.productImpressionProps,
      trkElementPosition = _ref.trkElementPosition,
      trkSectionPosition = _ref.trkSectionPosition,
      trkSectionCategory = _ref.trkSectionCategory;
  return /*#__PURE__*/React.createElement(BaseImpression, {
    analytics: productImpressionProps,
    destinationUrl: getApplyLink(marketplaceEntity),
    elementPosition: trkElementPosition,
    marketplaceInstitutionId: getInstitutionId(marketplaceEntity),
    marketplaceOfferId: getOfferId(marketplaceEntity),
    marketplaceProductId: getProductId(marketplaceEntity),
    marketplaceProductType: getProductType(marketplaceEntity) // todo: centralize types
    ,
    monetizable: getMonetizable(marketplaceEntity),
    sectionName: trkSectionCategory,
    sectionPosition: trkSectionPosition
  }, children);
};

if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable global-require, @typescript-eslint/no-var-requires, react/forbid-prop-types */
  var PropTypes = require('prop-types');

  BaseMarketplaceImpression.propTypes = {
    children: PropTypes.node.isRequired,
    marketplaceEntity: PropTypes.object.isRequired,
    productImpressionProps: PropTypes.object,
    trkElementPosition: PropTypes.number,
    trkSectionCategory: PropTypes.string,
    trkSectionPosition: PropTypes.number
  };
  /* eslint-enable global-require, @typescript-eslint/no-var-requires, react/forbid-prop-types */
}

export default BaseMarketplaceImpression;